import { language as lan_stepProductContent } from "./bulk-order-checkout-product-content";
import { language as lan_stepProductTip } from "./bulk-order-checkout-product-tip";
import { language as lan_stepShippingContent } from "./bulk-order-checkout-shipping-content";
import { language as lan_stepShippingTip } from "./bulk-order-checkout-shipping-tip";
import { language as lan_stepPaymentContent } from "./bulk-order-checkout-payment-content";
import { language as lan_stepPaymentTip } from "./bulk-order-checkout-payment-tip";

let language = {
    ...lan_stepProductContent,
    ...lan_stepProductTip,
    ...lan_stepShippingContent,
    ...lan_stepShippingTip,
    ...lan_stepPaymentContent,
    ...lan_stepPaymentTip,

    BULK_ORDER_CHECKOUT_NEXT_STEP_BTN: "Next",
    BULK_ORDER_CHECKOUT_BACK_STEP_BTN: "Back",
    BULK_ORDER_CHECKOUT_CANCEL_BTN: "Cancel",
    BULK_ORDER_CHECKOUT_GO_PAYMENT_BTN: "Go to Payment",

    BULK_ORDER_CHECKOUT_STEP_PRODUCT: "Products",
    BULK_ORDER_CHECKOUT_STEP_SHIPPING: "Shipping",
    BULK_ORDER_CHECKOUT_STEP_PAYMENT: "Payment",
};

export { language }